export default [
  {
    path: "/field1",
    name: "field1",
    meta: {
      title: "挖掘机专业服务",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果 这个不要删除 是home页面 方便测试！！！！！！！！！！！！！！
    },
    component: () => import("@/views/dycustom/home")
  },
  {
    path: "/field7dx", // 无视频
    name: "field7dx",
    meta: {
      title: "行业通用",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/dycustom/field7dx")
  },
  {
    path: "/ltOperation",
    name: "ltOperation",
    meta: {
      title: "联通开通教程",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/dycustom/ltOperation")
  },
  {
    path: "/dxOperation",
    name: "dxOperation",
    meta: {
      title: "电信开通教程",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/dycustom/dxOperation")
  },
  {
    path: "/blank",
    name: "blank",
    component: () => import("@/views/dycustom/blank"),
    meta: {
      title: "404"
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/manager.js